module.exports = __webpack_public_path__ + "img/searchList.e9062a31.svg";